import React from "react";
import styled from "styled-components";
import { BOX, CONTAINER } from "../about/About";
import SugarCosmetic from "../assets/sugarcosmetics.png";
import BlogApp from "../assets/blogapp.png";
import Sephora from "../assets/sephora.png";
import Indeed from "../assets/indeed.png";
import Medeasy from "../assets/medeasy.png";
import { COLOR1, COLOR2 } from "../global";

export const Projects = () => {
  return (
    <CONTAINER id="portfolio">
      <BOX>
        <p>My Work</p>
        <h2>Portfolio</h2>

        <PROJECTS_CONTAINER>
          {/* blogapp */}
          <PROJECT_CARD>
            <PROJECT_CARD_IMAGE>
              <img src={BlogApp} alt="BlogApp" />
            </PROJECT_CARD_IMAGE>

            <PROJECT_CARD_DISCRIPTION>
              <h3>Blog-App</h3>
              <p>
                Blog-App is a web application where user can perform
                CRUD operation for his posts and can see post from every user
                whatever they posts.
              </p>
            </PROJECT_CARD_DISCRIPTION>
            <PROJECT_CARD_TECH>
              <ul>
                <li>HTML</li>
                <li>CSS</li>
                <li>React</li>
                <li>NodeJs</li>
                <li>MongoDb</li>
                <li>Chakra-ui</li>
              </ul>
            </PROJECT_CARD_TECH>

            <PROJECT_CARD_LINKS>
              <a
                href="https://github.com/MitreshPrajapati/blogApp"
                target="_blank"
              >
                <button>Github</button>
              </a>
              <a href="https://blog-web-app-phi.vercel.app/" target="_blank">
                <button>Live </button>
              </a>
            </PROJECT_CARD_LINKS>
          </PROJECT_CARD>
          <PROJECT_CARD>
            <PROJECT_CARD_IMAGE>
              <img src={Sephora} alt="sephora-icon" />
            </PROJECT_CARD_IMAGE>

            <PROJECT_CARD_DISCRIPTION>
              <h3>Sephora-clone</h3>
              <p>
                Sephora is a French multinational retailer of famous beauty
                brand that has captured the hearts of millions of beauty
                shoppers worldwide. This company is also expanding around the
                globe and is available in several countries. The brand offers
                different beauty products from high-end beauty brands and makes
                them accessible to users even before purchase.
              </p>
            </PROJECT_CARD_DISCRIPTION>
            <PROJECT_CARD_TECH>
              <ul>
                <li>HTML</li>
                <li>CSS</li>
                <li>Javascript</li>
              </ul>
            </PROJECT_CARD_TECH>

            <PROJECT_CARD_LINKS>
              <a
                href="https://github.com/skismile/team-Sephora_project"
                target="_blank"
              >
                <button>Github</button>
              </a>
              <a href="https://cloneshephora.netlify.app/" target="_blank">
                <button>Live </button>
              </a>
            </PROJECT_CARD_LINKS>
          </PROJECT_CARD>
          {/* sugar */}
          <PROJECT_CARD>
            <PROJECT_CARD_IMAGE>
              <img src={SugarCosmetic} alt="sugar-icon" />
            </PROJECT_CARD_IMAGE>

            <PROJECT_CARD_DISCRIPTION>
              <h3>Sugar Cosmetics-clone</h3>
              <p>
                Sugar Cosmetics is a cruelty-free makeup brand that offers a
                wide range of premium makeup products. It is a cult favorite
                amongst millennials and is one of the fastest-growing premium
                beauty brands in India. With its clutter-breaking persona,
                signature low-poly packaging, and chart-topping products.
              </p>
            </PROJECT_CARD_DISCRIPTION>
            <PROJECT_CARD_TECH>
              <ul>
                <li>HTML</li>
                <li>CSS</li>
                <li>Javascript</li>
              </ul>
            </PROJECT_CARD_TECH>

            <PROJECT_CARD_LINKS>
              <a
                href="https://github.com/RohitMBelure/Project_Sugar_Cosmetics"
                target="_blank"
              >
                <button>Github</button>
              </a>
              <a
                href="https://beautiful-nasturtium-8b89b4.netlify.app/"
                target="_blank"
              >
                <button>Live </button>
              </a>
            </PROJECT_CARD_LINKS>
          </PROJECT_CARD>
          {/* Indeed  */}
          <PROJECT_CARD>
            <PROJECT_CARD_IMAGE>
              <img src={Indeed} alt="indeed" />
            </PROJECT_CARD_IMAGE>

            <PROJECT_CARD_DISCRIPTION>
              <h3>Indeed-clone</h3>
              <p>
                Indeed is a American worldwide employment website which is
                provide a free service to job seekers, where you can search any
                job from and for your preffered location and you can upload your
                resume.
              </p>
            </PROJECT_CARD_DISCRIPTION>
            <PROJECT_CARD_TECH>
              <ul>
                <li>React</li>
                <li>Redux</li>
                <li>CSS</li>
                <li>Styled-Components</li>
                <li>Javascript</li>
              </ul>
            </PROJECT_CARD_TECH>

            <PROJECT_CARD_LINKS>
              <a
                href="https://github.com/Chhattoo25/curved-knee-365"
                target="_blank"
              >
                <button>Github</button>
              </a>
              <a href="https://indeed-clone-ten.vercel.app/" target="_blank">
                <button>Live </button>
              </a>
            </PROJECT_CARD_LINKS>
          </PROJECT_CARD>

          {/* MedEasy */}
          <PROJECT_CARD>
            <PROJECT_CARD_IMAGE>
              <img src={Medeasy} alt="medeasy" />
            </PROJECT_CARD_IMAGE>

            <PROJECT_CARD_DISCRIPTION>
              <h3>MedEasy</h3>
              <p>
                MedEasy an e-pharma project, you can buy medicine online form
                here.
              </p>
            </PROJECT_CARD_DISCRIPTION>
            <PROJECT_CARD_TECH>
              <ul>
                <li>React</li>
                <li>Redux</li>
                <li>CSS</li>
                <li>Chakra-ui</li>
                <li>JSX</li>
                <li>MongoDB</li>
                <li>ExpressJs</li>
                <li>NodeJs</li>
              </ul>
            </PROJECT_CARD_TECH>

            <PROJECT_CARD_LINKS>
              <a
                href="https://github.com/Aditya-Raj-Dev/resilient-thrill-6327"
                target="_blank"
              >
                <button>Github</button>
              </a>
              <a href="https://pharmeasy-black.vercel.app/" target="_blank">
                <button>Live </button>
              </a>
            </PROJECT_CARD_LINKS>
          </PROJECT_CARD>
        </PROJECTS_CONTAINER>
      </BOX>
    </CONTAINER>
  );
};

const PROJECTS_CONTAINER = styled.div`
  border: 1px solid transparent;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 1rem;
  gap: 3rem;
  @media screen and (min-width: 768px) and (max-width: 1500px) {
    grid-template-columns: repeat(2, 2fr);
    padding: 0.2rem;
    gap: 2rem;
  }
  @media screen and (min-width: 300px) and (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 0.2rem;
    gap: 2rem;
  }
`;
const PROJECT_CARD = styled.div`
  border: 0.25px solid transparent;
  padding: 0 0 1rem 0;
  border-radius: 0.6rem;
  text-align: left;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
`;
const PROJECT_CARD_IMAGE = styled.div`
  border: 0.25px solid transparent;
  border-radius: 0.6rem;
  padding: 0.5rem;
  margin: auto;
  height: 12rem;
  // position: relative;
  img {
    display: block;
    // position: absolute;
    width: 100%;
    height: 100%;
    margin: auto;
    border: 1px solid black;
    border-radius: 0.6rem;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    height: 15rem;
  }

  @media screen and (min-width: 450px) and (max-width: 767px) {
    height: 15rem;
  }
  @media screen and (min-width: 300px) and (max-width: 449px) {
    height: 12rem;
  }
`;
const PROJECT_CARD_DISCRIPTION = styled.div`
  padding: 0 1rem;
  text-align: left;
  h3 {
    margin-top: 1rem;
  }
  p {
    line-height: 25px;
    color: grey;
  }
`;
const PROJECT_CARD_TECH = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0 1rem;
  flex-direction: column;
  ul {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    padding: 1rem 0;
    li {
      background-color: black;
      padding: 0.1rem 0.75rem;
      border-radius: 1rem;
      font-size: 12px;
      font-weight: 500;
      color: white;
    }
  }
`;
const PROJECT_CARD_LINKS = styled.div`
  display: flex;
  gap: 1rem;
  padding: 1rem;

  a {
    text-decoration: none;
    button {
      font-weight: 500;
      padding: 1rem 2rem;
      border-radius: 0.5rem;
      color: ${COLOR2};
      background-color: ${COLOR1};
      border: 1.5px solid transparent;

      &:hover {
        color: ${COLOR1};
        background-color: ${COLOR2};
        border: 1.5px solid ${COLOR1};
      }
    }
  }
`;
